module.exports = __webpack_public_path__ + "dingbeauty/admin/img/ga_1.33e7e70e.jpg";